<template>
  <!-- <img src="@/assets/images/logo/logo.png"> -->
  <img v-if=" customLogo != '' " :src="customLogo" />
  <img  v-else src="@/assets/images/logo/logo.png" />
</template>

<script>
export default {
  data() {
    return {
      customLogo: ''
    };
  },
  mounted(){
    this.handleAssets();
  },
  methods: {
    handleAssets(){
        this.$store
        .dispatch("GetAssets","main_logo")
        .then(response => {
            this.customLogo = response.data.data.path;
            this.$vs.loading.close();
        })
        .catch(error => {
            this.$vs.loading.close();
            // Error response
            this.$vs.notify({
                title: "Failed to configure assets",
                text: error,
                color: "danger",
                position: "top-center"
            });
            return false;
        });
    },
  }
};
</script>

